import { Routes } from '@angular/router';

import { ExerciseProblemComponent } from './exercise-problem/exercise-problem.component';
import { ExerciseStrategyComponent } from './exercise-strategy/exercise-strategy.component';
import { ExerciseIntroComponent } from './exercise-intro/exercise-intro.component';
import { ExerciseCompleteComponent } from './exercise-complete/exercise-complete.component';
import { ExerciseConcludeComponent } from './exercise-conclude/exercise-conclude.component';
import { DashboardUxComponent } from './dashboard-ux/dashboard-ux.component';

export const uxRoutes: Routes = [
  {
    path: 'ux',
    children: [
      {
        path: '',
        component: DashboardUxComponent,
      },
      {
        path: 'exercise',
        children: [
          {
            path: 'intro',
            component: ExerciseIntroComponent,
          },
          {
            path: 'problem',
            component: ExerciseProblemComponent,
          },
          {
            path: 'strategy',
            component: ExerciseStrategyComponent,
          },
          {
            path: 'complete',
            component: ExerciseCompleteComponent,
          },
          {
            path: 'conclude',
            component: ExerciseConcludeComponent,
          }
        ]
      }
    ]
  }
];
